export default __webpack_public_path__ + "static/media/pic_Generate.ed9e5a5b.svg";